export const ENDPOINTS = {
  session: "/session",
  languages: "/languages",
  customersMe: "/customers/me",
  customersMePlan: "/customers/me/plan",
  customersMeCount: "/customers/me/count",
  usersMe: "/users/me",
  customers: "/customers",
  usersPasswordRecovery: "/users/password/recovery",
  notifications: "/notifications",
  notificationsCount: "/notifications/count",
  shops: "/shops",
  layerVersions: "/layer/versions",
  featureFlagsEvaluateAll: "/api/evaluate/all",
  notificationsBulkRead: "/notifications/bulk/read",
  notificationsPage: (from: number, size: number) => `/notifications?from=${from}&size=${size}`,
  notificationRead: (id: number | string) => `/notifications/${id}/read`,
  shopConfiguration: (id: number | string) => `/shops/${id}/configuration`,
  shopLanguage: (id: number | string) => `/shops/${id}/language`,
  shopData: (id: number | string) => `/shops/${id}/data`,
  customerActivation: (id: string | number) => `/customers/${id}/activation`,
  usersPasswordRecoveryCode: (code: string) => `/users/password/recovery/${code}`,
  shopActivation: (id: number | string) => `/shops/${id}/activation`,
  shop: (id: number | string) => `/shops/${id}`,
  shopAttributes: (id: number | string) => `/shops/${id}/attributes`,
  shopLabel: (id: number | string) => `/shops/${id}/label`,
  shopSeo: (id: number | string) => `/shops/${id}/seo`,
  shopCategories: (id: number | string) => `/shops/${id}/categories`,
  shopFacets: (idOrKey: number | string) => `/shops/${idOrKey}/facets`,
  shopCustomCss: (id: number | string) => `/shops/${id}/custom-css`,
  shopVisualMachine: (id: number | string, tier?: 1) => `/shops/${id}/visual-machine${tier ? "?tier=1" : ""}`,
  shopVisualMachineRule: (id: number | string, ruleId: number | string, tier?: 1) =>
    `/shops/${id}/visual-machine/${ruleId}${tier ? "?tier=1" : ""}`,
  // `?` finale letterale, come il legacy: il backend risponde con le stats (categorie) della ricerca vuota.
  shopSearch: (key: string) => `/shops/${key}/search?`,
  shopVisualMachineSearch: (key: string) => `/shops/${key}/visual-machine/search`,
  shopRecommendations: (id: number | string) => `/shops/${id}/recommendations`,
  shopBuilder: (id: number | string) => `/shops/${id}/builder`,
  shopSeoValues: (id: number | string) => `/shops/${id}/seo/values`,
  shopLinguisticCopy: (id: number | string) => `/shops/${id}/configuration/linguistic/copy`,
  analyticsOverview: (id: number | string) => `/analytics/${id}/overview`,
  analyticsFacetsInfo: (id: number | string) => `/analytics/${id}/facets-info`,
  analyticsFacetInfo: (id: number | string) => `/analytics/${id}/facet-info`,
  analyticsQuery: (id: number | string) => `/analytics/${id}/query`,
  analyticsQueryInfo: (id: number | string) => `/analytics/${id}/query-info`,
  shopEventsOverview: (id: number | string) => `/shops/${id}/events/overview`,
  shopEvents: (id: number | string, type: string) => `/shops/${id}/events/${type}`,
  paymentMethods: "/customers/me/payment/methods",
  paymentMethodsStripe: "/customers/me/payment/methods/stripe",
  paymentMethod: (id: number | string) => `/customers/me/payment/methods/${id}`,
  paymentHistory: (from: number, to: number) => `/customers/me/payment/history?from=${from}&to=${to}`,
  plans: "/plans",
  customersMePlanPending: "/customers/me/plan/pending",
  customersMeActive: "/customers/me/active",
  searchTypes: "/search/types",
  checkFeed: "/integrations/google-shopping/check-feed",
} as const;
